<script type="text/javascript">
	import Tab,{ Label } from '@smui/tab';
	import TabBar from '@smui/tab-bar';
	import moment from "moment";
	import { get,writable } from "svelte/store";
	import AppStore from "../../AppStore";
	import AuthStore from "../../Auth/Store";
	import LoadState from "../../Enums/LoadState";
	import GeoHelper from "../../Helpers/GeoHelper";
	import StringHelper from "../../Helpers/StringHelper";
	import MapStore from "../../Map/Store";
	import ModalWindow from "../../UI/ModalWindow.svelte";
	import Spinner from "../Spinner/Spinner.svelte";
	import SpinnerSize from "../Spinner/SpinnerSize";
	import RiskIntPortsStore from "./PortsStore";

	let loadState = RiskIntPortsStore.meta.loadState;
	let loaded = false;
	$: {
		loaded = $loadState === LoadState.LOADED;
	}

	let visible = RiskIntPortsStore.meta.visible;
	RiskIntPortsStore.meta.visible.subscribe((visible) => {
		if (visible
			// User.hasFeature(Feature.TODO)
			) {
                RiskIntPortsStore.actions.initMap( MapStore.helpers.getMap() );
                RiskIntPortsStore.actions.init( MapStore.helpers.getMap() );
		}
        else {
            RiskIntPortsStore.actions.deinitMap();
        }
	});

	let ports = RiskIntPortsStore.results.ports;
	let lastUpdated = RiskIntPortsStore.meta.lastUpdated;
	$: {
		$visible;
        if (!$visible) {
            $portVisible = false;
            $currentPort = null;
        }
		$lastUpdated;
		RiskIntPortsStore.actions.updateFeatureCollection();
		// RiskIntPortsStore.actions.updateVisibility();
	}

	$: {
		$lastUpdated;
        $ports = $ports;
	}


    let dateFormat = "Do MMMM YYYY";

    let portVisible = RiskIntPortsStore.meta.portVisible;
	let currentPort = RiskIntPortsStore.meta.selectedPort;

    let windowInstance = null;


    let portsInfoTabs = ["Info", "Port Threat Assessment"]; //, "City Threats", "Country Threats"];
    let portWindowTab = writable("Info");

    let subcategoryLoadState = writable(LoadState.INIT);
    let subcategoryData = writable({});

    $: {
        if ($visible && $portVisible && $portWindowTab === "Port Threat Assessment") {
            subcategoryLoadState = RiskIntPortsStore.helpers.getPortSubcategory($currentPort.id, "threat-assessment").loadState;
            subcategoryData = RiskIntPortsStore.helpers.getPortSubcategory($currentPort.id, "threat-assessment").result;
            RiskIntPortsStore.actions.loadSubcategoryData($currentPort.id, "threat-assessment");
        }
    }

</script>

<style type="text/scss">


.ri-port-box {
	padding:15px;
	border:1px solid #ddd;
	border-radius: 8px;
	margin-bottom: 8px;
	p, h5 {
		margin-top: 2px;
		margin-bottom: 2px;
		line-height: 22px;
	}
    img.icon {
        width:16px;
        height:16px;
        margin-top:3px;
        margin-bottom:3px;
        margin-right:6px;
    }
}
.ri-port-modal-content {
    h5 {
		margin-top: 2px;
		margin-bottom: 2px;
		line-height: 22px;
	}
    p {
        line-height:22px;
    }
    img.icon {
        width:16px;
        height:16px;
        margin-top:3px;
        margin-bottom:3px;
        margin-right:6px;
    }
}
.threat-level-1, .threat-level-2 {
    color: #3c9d38;
}
.threat-level-3 {
    color: #fccb32;
}
.threat-level-4, .threat-level-5 {
    color: #d0101e
}

</style>


<ModalWindow
    title={`Risk Intelligence - Ports`}
    hasCloseButton={true}
    hasBackground={false}
    resizable={true}
    draggable={true}
    fullscreen={false}
    padding={true}
    position="top-right"
    height="70%"
    bind:this={windowInstance}
    bind:open={$visible}>

    {#if $loadState === LoadState.LOADING}
        <div class="spinner-center">
            <Spinner size={SpinnerSize.SMALL} absolute={false} inline={true} />
        </div>
    {/if}
    {#if $loadState === LoadState.LOADED}


            {#each $ports as port (port.id)}

                    <div class='ri-port-box oa'>

                        <!-- {#if incident.area !== null}{({incident.area.name}){/if} -->
                        <h5>{port.name}</h5>
                        <!-- <p class='text-muted'>{@html incident.teaser}</p> -->
                        <button class='btn btn-sm fl bg-primary mr-3' on:click={()=>{
                            RiskIntPortsStore.actions.openPort(port.id);
                        }}>Open</button>
                        <button class='btn btn-sm fl bg-secondary' on:click={()=>{
                            MapStore.helpers.zoomToPoint([port.position.longitude, port.position.latitude]);
                        }}>Go to</button>
                        <!-- <td>{feature.attributes.ThreatLevel}</td>
                        <td>{moment.utc(feature.attributes.AssessmentDate).format("MMM Do YYYY")}</td>
                        <td>
                            <button class='btn btn-sml bg-info' on:click={()=>{
                                Analytics.event("open_assessment_" + feature.attributes.Name, { category: "Ports", username: get(AuthStore.userInfo).username, portName: feature.attributes.Name });
                                window.open(feature.attributes.PortAssessmentURL);
                            }}>Open</button>
                            <button class='btn btn-sml bg-info' on:click={()=>{
                                MapStore.helpers.zoomToPoint([feature.geometry.x, feature.geometry.y]);
                            }}>Find</button>
                        </td> -->
                    </div>
                    <p style="display:none">{$lastUpdated}</p>

            {/each}
    {/if}
</ModalWindow>

{#if $visible && $portVisible && $currentPort !== null}
    <ModalWindow
        title={$currentPort.name}
        hasCloseButton={true}
        hasBackground={false}
        resizable={true}
        draggable={true}
        fullscreen={false}
        padding={false}
        position="top-right"
        height="70%"
        bind:open={$portVisible}
        parent={windowInstance}
        >
        <TabBar tabs={portsInfoTabs} let:tab bind:active={$portWindowTab} class="border-shadow">
            <Tab tab={tab} minWidth><Label>{tab}</Label></Tab>
        </TabBar>
        <div class="content padding ri-port-modal-content">
            {#if $portWindowTab === "Info"}
                <div class='oa'>
                    <div class='oa' style="margin-bottom:14px;">
                        <h5 class='text-muted fl'>{$currentPort.country.name}</h5>
                        <h5 class='text-muted fr'>{moment($currentPort.date).format(dateFormat)}</h5>
                    </div>

                    <table class='table svelte-table' style="width:100%;">
                        <tr>
                            <td>UNLOCODE</td>
                            <td align='right'>{$currentPort.unlocode}</td>
                        </tr>
                        <tr>
                            <td>PortRisk Assessment Level</td>
                            <td align='right'>PAL {$currentPort.pal}</td>
                        </tr>
                        <tr>
                            <td>ISPS Security Level</td>
                            <td align='right'>{$currentPort.ispsSecurityLevel.description}</td>
                        </tr>
                        <tr>
                            <td>Position</td>
                            <td align='right'>{GeoHelper.lngLatCoordinatesToString([$currentPort.position.longitude, $currentPort.position.latitude], get(AuthStore.session.user).lngLatFormat, 4)}</td>
                        </tr>
                    </table>
                    {#if $currentPort.images && $currentPort.images.length > 0}
                        <h5 class='text-muted fl' style="margin-bottom:0.75em;">Images</h5>
                        <div style="width:100%;overflow-y:hidden;overflow-x:scroll;white-space:nowrap">
                            {#each $currentPort.images as image, index}
                                <img on:click={()=>{
                                    AppStore.actions.addImagePreview(image.url, $currentPort.name + " - Image #" + (index+1));
                                }} src={image.url} alt="Port image" style="cursor:pointer;width:37%;margin-right:5px;display:inline-block;border-radius:3px;"/>
                            {/each}
                        </div>
                    {/if}
                    <!-- Joint War Committee -->
                    <!-- Foreign Flag state -->
                    <!-- Security Risk Assessment
                    Vulnerability Assessment
                    Agencies
                    City Information
                    Documents
                    Download PDF -->

                </div>
            {:else if $portWindowTab === "Port Threat Assessment"}
                {#if $subcategoryLoadState === LoadState.LOADING}
                    Loading...
                {:else if $subcategoryLoadState === LoadState.LOADED}
                    <!-- {JSON.stringify($subcategoryData)} -->

                    <p style='margin-top:0.5em;'><b>{moment($subcategoryData["threat-assessment"].date).format(dateFormat)}</b></p>
                    <p>{@html StringHelper.nl2br($subcategoryData["threat-assessment"].summary)}</p>

                    {#each $subcategoryData["threat-assessment"].threats as threat}
                        <div>
                            <div class='oa' style='cursor:pointer;width:calc(100% - 20px);padding-left:10px;padding-right:10px;background-color:#eee;border-bottom:1px solid #ccc;' on:click={()=>{
                                threat.visible = !!!threat.visible;
                             }}>
                                <p class='fl'><b>{threat.type.description}</b></p>
                                <p class='fr'
                                    class:threat-level-1={threat.level.id===1}
                                    class:threat-level-2={threat.level.id===2}
                                    class:threat-level-3={threat.level.id===3}
                                    class:threat-level-4={threat.level.id===4}
                                    class:threat-level-5={threat.level.id===5}
                                    ><b>{threat.level.description}</b></p>
                            </div>
                            {#if threat.visible}
                                <div class='padding'>
                                    <p>{@html StringHelper.nl2br(threat.description)}</p>
                                </div>
                            {/if}
                        </div>
                    {/each}


                {/if}


            {:else if $portWindowTab === "City Threats"}
                City Threats
            {:else if $portWindowTab === "Country Threats"}
                Country Threats
            {/if}
        </div>
    </ModalWindow>
{/if}

